var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder",
    attrs: {
      "id": "library-cards"
    }
  }, [(_vm.$store.getters.getMostWatchedLos !== undefined && _vm.$store.getters.getMostWatchedLos !== null && _vm.$store.getters.getMostWatchedLos.length > 0) ? _c('div', {
    staticClass: "pb-2 row"
  }, [_c('h6', {
    staticClass: "main-title col-12 text-left"
  }, [_vm._v(_vm._s(_vm.$t('libraryCards.labels.most_watched_Videos')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-alert', {
    staticClass: "alert-info",
    attrs: {
      "dismissible": "",
      "show": true
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = true
      }
    }
  }, [_c('strong', [_vm._v("Single Concepts")]), _vm._v(" are videos less than 2 hours in length that explains a single concept.\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getMostWatchedLos !== undefined && _vm.$store.getters.getMostWatchedLos !== null && _vm.$store.getters.getMostWatchedLos.length > 0) ? _c('div', {
    staticClass: "swiper-holder"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption2
    }
  }, [_vm._l((_vm.$store.getters.getMostWatchedLos), function(item, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "card-design"
    }, [(item.thumbnail.length != 0) ? _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": _vm.makePath(item.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "data-src": "../../../static/assets/images/defaultLO.jpg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [_c('div', {
      staticClass: "lo-label"
    }, [_vm._v(_vm._s(_vm.$t('libraryCards.labels.lo_label')))]), _vm._v(" "), _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading no-line text-truncate",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(item.price) + " " + _vm._s(item.price > 1 ? 'Points' : 'Point '))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]) : _vm._e(), _vm._v(" "), (parseInt(item.rating) == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(item.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('div', [_c('star-rating', {
      attrs: {
        "rating": parseInt(item.rating.toFixed(1)),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
      staticClass: "row mt-3"
    }, [(
      (_vm.$store.getters.getItemSubscriptionStatus({
          'id': item.contentId,
          'type': item.type
        }) != undefined &&
        _vm.$store.getters.getItemSubscriptionStatus({
          'id': item.contentId,
          'type': item.type
        }) != null &&
        _vm.$store.getters.getItemSubscriptionStatus({
          'id': item.contentId,
          'type': item.type
        })) ||
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': item.tagList
      }) != undefined &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': item.tagList
      }) != null &&
      _vm.$store.getters.getTagAllocationStatus({
        'contentTagList': item.tagList
      })
    ) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.playLO(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.PLAY_NOW')))])]) : (_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [(_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(item.contentId)) ? _c('button', {
      staticClass: "btn btn-green-alt"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))]) : _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(item.contentId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList && _vm.featureStatusInfoList.wishlist && _vm.$store.getters.getItemPurchasedStatus(item.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(item.contentId) != null && !_vm.$store.getters.getItemPurchasedStatus(item.contentId)) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [(_vm.$store.getters.itemPresentInWishListStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInWishListStatus(item.contentId) != null && _vm.$store.getters.itemPresentInWishListStatus(item.contentId)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && !_vm.$store.getters.itemPresentInCartStatus(item.contentId)),
        expression: "$store.getters.itemPresentInCartStatus(item.contentId) != undefined && $store.getters.itemPresentInCartStatus(item.contentId)!= null && !$store.getters.itemPresentInCartStatus(item.contentId)"
      }],
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.removeFromWishList(item.contentId)
        }
      }
    })]) : (_vm.$store.getters.itemPresentInCartStatus(item.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(item.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(item.contentId)) ? _c('div') : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.addToWishList(item.contentId)
        }
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row mt-3"
    }, [(_vm.featureStatusInfoList && _vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList && _vm.featureStatusInfoList.wishlist) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    })]) : _vm._e()])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c85914b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/libraryCards.vue
// module id = QHXS
// module chunks = 1